const SAMPLE_PAGE = {
	name: "My First Page",
	title: "My First Page",
	moduleId: "5c51e7b646b8bd4c607d8e2c",
	properties: {
		content:
			'<p><br></p>\n<h1>Welcome To Your App</h1>\n<p>This is some starter text. You can change it, remove it, or add to it however you like. Or, if you\'re looking for more features you can check out the other modules above.</p>\n<p><br></p>\n<figure><img src="https://i.pinimg.com/originals/b3/3f/e9/b33fe93d646ddb4289856fff8bad5ea8.gif"/></figure>\n<p><br></p>\n<p>...We also added a link</p>',
	},
};

export default SAMPLE_PAGE;
